import { render } from "./DatasetSegmentsItem.vue?vue&type=template&id=70b1389e"
import script from "./DatasetSegmentsItem.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__